import { css } from 'lit';
export default css `
  :host > wui-flex:first-child {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
`;
//# sourceMappingURL=styles.js.map